import { render, staticRenderFns } from "./EffortActions.vue?vue&type=template&id=9d67f7b4&scoped=true&"
import script from "./EffortActions.vue?vue&type=script&lang=js&"
export * from "./EffortActions.vue?vue&type=script&lang=js&"
import style0 from "./EffortActions.vue?vue&type=style&index=0&id=9d67f7b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d67f7b4",
  null
  
)

export default component.exports